import React from 'react';
import { useWindowDimensions } from 'react-native';
import { Defs, Line, Pattern, Rect, Svg } from 'react-native-svg';
import { DT } from './tokens';

type Props = {
  children: React.ReactNode;
  viewBox?: string;
  /** Width — pass number for fixed px, or "100%" (default) for fluid. */
  width?: number | string;
  height?: number;
};

/**
 * Base blueprint canvas for all annotated diagrams.
 * Fills the available screen width and scales height to maintain aspect ratio.
 */
export function DiagramCanvas({ children, viewBox = DT.viewBox, width, height }: Props) {
  const { width: screenWidth, height: screenHeight } = useWindowDimensions();
  const [, , vw, vh] = viewBox.split(' ').map(Number);

  const padding = 32;
  const numericWidth = width != null && typeof width === 'number' ? width : screenWidth - padding;
  const rawHeight = height ?? Math.round((vh / vw) * numericWidth);

  // Scale down proportionally if diagram would be too tall for the screen
  const maxHeight = screenHeight - 180;
  const scale = rawHeight > maxHeight ? maxHeight / rawHeight : 1;
  const svgWidth = Math.round(numericWidth * scale);
  const svgHeight = Math.round(rawHeight * scale);

  return (
    <Svg
      width={svgWidth}
      height={svgHeight}
      viewBox={viewBox}
      style={{ borderRadius: 10, overflow: 'hidden' }}
    >
      <Defs>
        <Pattern id="grid" width="20" height="20" patternUnits="userSpaceOnUse">
          <Line x1="20" y1="0" x2="20" y2="20" stroke={DT.grid} strokeWidth="0.5" />
          <Line x1="0" y1="20" x2="20" y2="20" stroke={DT.grid} strokeWidth="0.5" />
        </Pattern>
      </Defs>
      {/* Background */}
      <Rect width={vw} height={vh} fill={DT.bg} />
      {/* Grid */}
      <Rect width={vw} height={vh} fill="url(#grid)" />
      {children}
    </Svg>
  );
}
